/**
 * Stream response from an API endpoint, processing chunks as they arrive.
 */
export async function streamFromEndpoint(
	url: string,
	body: Record<string, unknown>,
	onChunk: (fullText: string) => void,
	onError: (message: string) => void,
	onComplete?: (fullText: string) => void
): Promise<void> {
	const res = await fetch(url, {
		method: 'POST',
		headers: { 'Content-Type': 'application/json' },
		body: JSON.stringify(body)
	});

	if (!res.ok) {
		const err = await res.json().catch(() => ({ error: 'Request failed.' }));
		onError(err.error || 'Request failed.');
		return;
	}

	if (!res.body) {
		onError('No response body received.');
		return;
	}

	const reader = res.body.getReader();
	const decoder = new TextDecoder();
	let fullText = '';

	try {
		while (true) {
			const { done, value } = await reader.read();
			if (done) break;
			fullText += decoder.decode(value, { stream: true });
			onChunk(fullText);
		}
		onComplete?.(fullText);
	} catch {
		if (fullText) {
			onChunk(fullText + '\n[Connection interrupted]');
		} else {
			onError('Connection lost during response.');
		}
	} finally {
		reader.releaseLock();
	}
}
